/* generated using generate-extended-services -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import {ApiRequestOptionsExtended} from '../../../utils/axios/core/request';
import {BaseHttpRequest} from '../core/BaseHttpRequest';
import {UsageStatsService} from '../services/UsageStatsService';

export class UsageStatsServiceExtended extends UsageStatsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {
    super(httpRequest);
  }

  /**
   * Export usage data as CSV. Includes summary, per-feature breakdown, and transaction details.
   * @returns FileContentResult OK
   * @throws ApiError
   */
  public usageStatsExportCsv({
    period = 'current',
    from,
    to,
  }: {
    period?: string;
    from?: string;
    to?: string;
  }): ReturnType<UsageStatsService['usageStatsExportCsv']> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/usage-stats/export',
      query: {
        period: period,
        from: from,
        to: to,
      },
      errors: {
        401: `Unauthorized`,
      },
      responseType: 'blob',
    } as ApiRequestOptionsExtended);
  }
}
